module.exports = __webpack_public_path__ + "img/滑梯.8cac8d50.png";